import { Component, inject, Input, OnInit } from '@angular/core';
import { HeaderConfigurationComponent } from '../../../../../../../../components/ecosystems/header-configuration/header-configuration.component';
import { IonButton, IonContent } from '@ionic/angular/standalone';
import { LabelDescriptionComponent } from '../../../../../../../../components/ecosystems/label-description/label-description.component';
import { LargedLinkComponent } from '../../../../../../../../components/ecosystems/larged-link/larged-link.component';
import { TranslatePipe } from '@ngx-translate/core';
import { TwoChoicesControlComponent } from '../../../../../../../../components/ecosystems/two-choices-control/two-choices-control.component';
import {
  DeviceActionStackService,
  EdroNetworkManager,
} from '../../../../../../manager/edro-network-manager';
import { SlideModalController } from '../../../../../../../slide-modal.service';
import {
  Pool,
  PoolAdditionalData,
} from '../../../../../../../../apis/pool.api';
import { IProduct } from '../../../../../IProduct';
import { FunctionParametersSettingsClockWpComponent } from '../../../../P00061/Component/function-parameters-settings-clock-wp/function-parameters-settings-clock-wp.component';
import { FunctionParametersSettingClockWeekWpComponent } from '../../../../P00061/Component/function-parameters-setting-clock-week-wp/function-parameters-setting-clock-week-wp.component';
import { P00039DataRxTxIndex } from '../../../../P00039Sync';

@Component({
  selector: 'app-p00062-chauffage-mise-en-oeuvre-programmation',
  templateUrl: './p00062-chauffage-mise-en-oeuvre-programmation.component.html',
  styleUrls: ['./p00062-chauffage-mise-en-oeuvre-programmation.component.scss'],
  imports: [
    HeaderConfigurationComponent,
    IonButton,
    IonContent,
    LabelDescriptionComponent,
    LargedLinkComponent,
    TranslatePipe,
    TwoChoicesControlComponent,
  ],
})
export class P00062ChauffageMiseEnOeuvreProgrammationComponent
  implements OnInit
{
  private edroNetworkManager: EdroNetworkManager = inject(EdroNetworkManager);
  private slideModalService: SlideModalController =
    inject(SlideModalController);
  @Input() prev: () => void = () => {};
  @Input() next: (
    actionStack: DeviceActionStackService,
    poolAdditionalData: PoolAdditionalData,
  ) => void = () => {};

  @Input() productClass: IProduct | null = null;

  @Input() poolAdditionalData: PoolAdditionalData | null = null;

  @Input() actionStackParam: any | null = null;
  actionStack: DeviceActionStackService | null = null;

  @Input() pool: Pool | null = null;

  constructor() {}

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      this.actionStackParam,
    );
  }

  async goToFunctionParametersSettingsClockScreen() {
    const modal = await this.slideModalService.create({
      component: FunctionParametersSettingsClockWpComponent,
      componentProps: {
        value: [
          this.actionStack!.getValue('ppPHorlogeJourLundi'),
          this.actionStack!.getValue('ppPHorlogeJourMardi'),
          this.actionStack!.getValue('ppPHorlogeJourMercredi'),
          this.actionStack!.getValue('ppPHorlogeJourJeudi'),
          this.actionStack!.getValue('ppPHorlogeJourVendredi'),
          this.actionStack!.getValue('ppPHorlogeJourSamedi'),
          this.actionStack!.getValue('ppPHorlogeJourDimanche'),
        ],
      },
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      const hj = data.value;

      this.actionStack!.editValue(
        P00039DataRxTxIndex.PACPOLY_Parametrage3,
        'ppPHorlogeJourLundi',
        hj[0],
        null,
      );
      this.actionStack!.editValue(
        P00039DataRxTxIndex.PACPOLY_Parametrage4,
        'ppPHorlogeJourMardi',
        hj[1],
        null,
      );
      this.actionStack!.editValue(
        P00039DataRxTxIndex.PACPOLY_Parametrage5,
        'ppPHorlogeJourMercredi',
        hj[2],
        null,
      );
      this.actionStack!.editValue(
        P00039DataRxTxIndex.PACPOLY_Parametrage6,
        'ppPHorlogeJourJeudi',
        hj[3],
        null,
      );
      this.actionStack!.editValue(
        P00039DataRxTxIndex.PACPOLY_Parametrage7,
        'ppPHorlogeJourVendredi',
        hj[4],
        null,
      );
      this.actionStack!.editValue(
        P00039DataRxTxIndex.PACPOLY_Parametrage8,
        'ppPHorlogeJourSamedi',
        hj[5],
        null,
      );
      this.actionStack!.editValue(
        P00039DataRxTxIndex.PACPOLY_Parametrage9,
        'ppPHorlogeJourDimanche',
        hj[6],
        null,
      );
    }
  }

  async goToFunctionParametersSettingClockWeekScreen() {
    const modal = await this.slideModalService.create({
      component: FunctionParametersSettingClockWeekWpComponent,
      componentProps: {
        value: this.actionStack!.getValue('ppPHorlogeSemaine'),
      },
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      const hj = data.value;
      this.actionStack!.editValue(
        P00039DataRxTxIndex.PACPOLY_Parametrage2,
        'ppPHorlogeSemaine',
        hj,
        null,
      );
    }
  }

  onSubmit() {
    this.next(this.actionStack!, this.poolAdditionalData!);
  }

  protected readonly P00039DataRxTxIndex = P00039DataRxTxIndex;
}
